module.exports = {
	"apiData": {
		"title": "XYZ API title 입니다.",
		"content": "XYZ API content 입니다.",
		"apiTestCode": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./travel-developers-interface/src/main/client/static/content/api/XYZ.json
// module id = 3744858885512850
// module chunks = 0 2 3